// extracted by mini-css-extract-plugin
export default {"ContentContainer":"EmptyList_ContentContainer__4Pbme","EmptyListLabel":"EmptyList_EmptyListLabel__1dbXV"};